export default __webpack_public_path__ + "static/media/person_image_3.073c75fd.png";